export const actions = {
  about: 'Despre proiect',
  lessons: 'Lecții disponibile',
  contact: 'Contactează-ne',
  donate: 'Donează',
}
